import { capitalCase } from 'change-case';
import { User } from './types';
import { identify } from './identify';
import { destroy } from './destroy';
import { init } from './init';
import config from '@/config/client';

export const refresh = (helpscoutUser: User, oldHelpscoutUser: User, analyticsConsent: boolean) => {
  // use language specific beacon or default (en)
  const helpscoutBeaconId =
    config[`helpscoutBeacon${capitalCase(helpscoutUser?.language ?? '')}Id`] ?? config.helpscoutBeaconDefaultId;

  if (window.Beacon) {
    let waitForReady = false;

    const beaconInfo = window.Beacon('info');
    const currentBeaconId = beaconInfo?.beaconId;

    if (!beaconInfo) {
      init();
      window.Beacon('init', helpscoutBeaconId);
      waitForReady = true;
    } else if (helpscoutUser.language !== oldHelpscoutUser?.language && currentBeaconId !== helpscoutBeaconId) {
      destroy();
      init();
      window.Beacon('init', helpscoutBeaconId);
      waitForReady = true;
    }

    if (analyticsConsent) {
      if (waitForReady) {
        window.Beacon('once', 'ready', () => {
          identify(helpscoutUser);
        });
      } else {
        // window.Beacon('logout');
        identify(helpscoutUser);
      }
    }
  }
};
